import { tv } from "tailwind-variants";

/**
 * Style
 */

const { bg, text } = tv({
  slots: {
    bg: "flex justify-center items-center w-[1.5rem] font-bold rounded cursor-pointer",
    text: "font-semibold text-[.60rem]"
  },
  variants: {
    color: {
      red: {
        bg: "bg-red-500",
        text: "text-white"
      },
      blue: {
        bg: "bg-blue-500",
        text: "text-white"
      },
      "blue-light": {
        bg: "bg-blue-300",
        text: "text-white"
      },
      yellow: {
        bg: "bg-yellow-400",
        text: "text-black"
      },
      green: {
        bg: "bg-primary-green",
        text: "text-white"
      },
      gray: {
        bg: "bg-gray-500",
        text: "text-white"
      },
    }
  }
})();

/**
 * LegendTagIcon
 */

type Props = {
  color: 'red' | 'blue' | 'blue-light' | 'yellow' | 'green' | 'gray',
  title: string,
} | {
  bgColor?: string,
  textColor?: string,
  title: string,
};

export const LegendTagIcon = ({
  title,
  ...props
}: Props) => {
  const finalColor = 'color' in props ? props.color : 'gray';
  const finalBgColor = 'bgColor' in props ? props.bgColor : undefined;
  const finalTextColor = 'textColor' in props ? props.textColor : 'white';

  return (
    <div className={bg({ color: finalColor })} style={{ backgroundColor: finalBgColor }}>
      <h1
        className={text({ color: finalColor })}
        style={{ color: finalTextColor, textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000' }}>
        {title}
      </h1>
    </div>
  );
}